<app-header [isWelcome]="true" data-testid="welcome-header"></app-header>
<div style="padding: 24px 20px 14px 20px" data-testid="welcome-container">
  <div class="headline1" data-testid="welcome-title">{{ locale.currentTranslation.welcomeHeader }}</div>
  <div class="headline4" data-testid="welcome-subtitle">{{locale.currentTranslation.welcomeSubHeader}}</div>
  <div style="display: flex; gap: 8px; flex-direction: column; margin-top: 24px;" data-testid="main-actions">
    <app-card routerLink="/insurance-information"
              [label]="locale.currentTranslation.welcomeReportDamage"
              [src]="'assets/img/card-claim-report.png'"
              data-testid="card-report-damage"
              role="button"
              [attr.aria-label]="locale.currentTranslation.welcomeReportDamage"></app-card>
    <app-card
      [label]="locale.currentTranslation.welcomeProvideDocuments"
      [src]="'assets/img/card-provide-documents.png'"
      [comingSoon]="true"
      data-testid="card-provide-documents"
      role="button"
      [attr.aria-label]="locale.currentTranslation.welcomeProvideDocuments"
    ></app-card>
    <app-card
      [label]="locale.currentTranslation.welcomeEditClaim"
      [src]="'assets/img/card-edit-claim.png'"
              [comingSoon]="true"
              data-testid="card-edit-claim"
              role="button"
              [attr.aria-label]="locale.currentTranslation.welcomeEditClaim"></app-card>
  </div>
  <div>
    <div class="label1 action-list-header" data-testid="additional-actions-header">{{ locale.currentTranslation.additionalActions}}</div>
  </div>
  <div data-testid="additional-actions-list">
    <app-action-list-item [label]="locale.currentTranslation.whatToDoIncident" routerLink="/what-to-do" data-testid="action-what-to-do"></app-action-list-item>
    <app-action-list-item [label]="locale.currentTranslation.faq" routerLink="/faq" data-testid="action-faq"></app-action-list-item>
    <app-action-list-item [label]="locale.currentTranslation.aboutPolicyholder" routerLink="/about-policyholder" data-testid="action-about-policyholder"></app-action-list-item>
    <app-action-list-item [label]="locale.currentTranslation.aboutInsurer" routerLink="/about-insurer" data-testid="action-about-insurer"></app-action-list-item>
  </div>
  <app-footer data-testid="welcome-footer"></app-footer>
</div>
